import { default as ElementLoader } from "./element_loader";
export default ElementLoader


// WEBPACK FOOTER //
// ./src/views/components/element_loader/index.js